import React from 'react'
import Pixelizer from './pixelizer'

const ColoringApp = () => {
    return (
        <Pixelizer />
    )
}

export default ColoringApp